import {NgModule} from '@angular/core';
import {Scanner3dModule} from './scanner3d/scanner3d.module';
import {Scan3dModule} from './scan3d/scan3d.module';
import {InsolesModule} from './insoles/insoles.module';
import {InsoleElementDefinitionModule} from "./element/definition/insoleElementDefinition.module";
import {InsolesProviderModelModule} from "./provider/model/insolesProviderModel.module";
import {InsoleCadProcessModule} from "./cad/insoleCadProcess.module";
import {InsolesProfileModule} from "./profile/insolesProfile.module";
import {InsolesModelModule} from "./insolemodel/insolesModel.module";
import {InsoleMaterialModule} from "./material/insoleMaterial.module";
import {InsoleProviderModule} from "./provider/insoleProvider.module";
import {CamModule} from "./cam/cam.module";
import {
    SubscriptionMetadataDefinitionRegistry
} from "../subscription/api/service/subscriptionMetadataDefinition.registry";
@NgModule({
    imports: [
        Scanner3dModule,
        Scan3dModule,
        InsolesModule,
        InsoleElementDefinitionModule,
        InsoleProviderModule,
        InsoleCadProcessModule,
        InsolesProfileModule,
        InsolesModelModule,
        InsoleMaterialModule,
        CamModule,
    ]
})
export class InsoleModule {
    constructor(private subscriptionMetadataDefinitionRegistry : SubscriptionMetadataDefinitionRegistry) {
        this.subscriptionMetadataDefinitionRegistry.register({
            modeling: {
                label: 'Modélisation',
                fields: {
                    "insole.bevel.version": {
                        label: "Version des biseaux",
                        type: "select",
                        options: [
                            { value: "1", label: "Standards (v1)" },
                            { value: "2", label: "Personnalisables (v2)" },
                        ],
                    },
                    "insole.border.version": {
                        label: "Version du bord latéral interne",
                        type: "select",
                        options: [
                            { value: "1", label: "Standards (v1)" },
                            { value: "2", label: "Personnalisables (v2)" },
                        ],
                    },
                    "insole.rear.smooth.nbIterations": {
                        label: "Lissage de l'arrière-pied",
                        type: "number",
                        min: 0,
                        max: 100,
                    },
                }
            },
            parcel: {
                label: 'Envois',
                fields: {
                    useV2App: {
                        label: "Utiliser l’application V2",
                        type: "boolean",
                    },
                }
            },
        });
    }
}

